import * as React from "react";

export const LightOrDarkHairGene = (): React.ReactElement => (
  <svg
    width="329"
    height="297"
    viewBox="0 0 329 297"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1168_39633)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.9004 5.76862C37.3187 5.76862 40.9004 9.35033 40.9004 13.7686L40.9004 74.9686C40.9004 77.586 39.6434 79.9098 37.7002 81.3693V84.5679C39.6434 86.0274 40.9004 88.3512 40.9004 90.9686L40.9004 269.769C40.9004 274.187 37.3187 277.769 32.9004 277.769C28.4821 277.769 24.9004 274.187 24.9004 269.769L24.9004 90.9686C24.9004 88.1758 26.3315 85.7172 28.5004 84.2862V81.651C26.3315 80.22 24.9004 77.7614 24.9004 74.9686L24.9004 13.7686C24.9004 9.35033 28.4821 5.76862 32.9004 5.76862Z"
        fill="#F7FAFC"
      />
      <rect x="24.9004" y="28.9686" width="15.9997" height="8" fill="#E2E8F0" />
      <rect
        x="24.9004"
        y="40.5686"
        width="15.9997"
        height="20"
        fill="#E2E8F0"
      />
      <rect
        x="24.9004"
        y="66.1686"
        width="15.9997"
        height="3.2"
        fill="#E2E8F0"
      />
      <mask
        id="mask0_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="24"
        y="76"
        width="17"
        height="14"
      >
        <path
          d="M40.9002 76.1686C40.9002 78.4622 39.5567 80.4899 37.5003 81.717V84.1817C39.5567 85.4089 40.9003 87.4365 40.9003 89.7301L24.9004 89.7302C24.9004 87.4365 26.244 85.4088 28.3005 84.1817V81.7171C26.244 80.49 24.9004 78.4623 24.9004 76.1686H40.9002Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask0_1168_39633)">
        <path
          d="M24.9004 77.0138H40.9001V89.0138H24.9004V77.0138Z"
          fill="#EDF2F7"
        />
      </g>
      <rect
        x="24.9004"
        y="100.969"
        width="15.9997"
        height="12"
        fill="#E2E8F0"
      />
      <rect x="24.9004" y="121.769" width="15.9997" height="4" fill="#E2E8F0" />
      <rect x="24.9004" y="132.569" width="16" height="20" fill="#E2E8F0" />
      <rect x="24.9004" y="158.169" width="16" height="20" fill="#E2E8F0" />
      <rect x="24.9004" y="182.569" width="16" height="8" fill="#E2E8F0" />
      <rect x="24.9004" y="192.169" width="16" height="8" fill="#E2E8F0" />
      <rect x="24.9004" y="215.369" width="16" height="4" fill="#E2E8F0" />
      <rect x="24.9004" y="229.769" width="16" height="8.8" fill="#E2E8F0" />
      <rect x="24.9004" y="242.169" width="16" height="3.2" fill="#E2E8F0" />
      <rect x="24.9004" y="248.169" width="16" height="16" fill="#E2E8F0" />
      <rect x="24.9004" y="265.769" width="16" height="4" fill="#E2E8F0" />
    </g>
    <path
      d="M35.706 288.797H31.962V290.453C32.122 290.277 32.346 290.133 32.634 290.021C32.922 289.909 33.234 289.853 33.57 289.853C34.17 289.853 34.666 289.989 35.058 290.261C35.458 290.533 35.75 290.885 35.934 291.317C36.118 291.749 36.21 292.217 36.21 292.721C36.21 293.657 35.946 294.401 35.418 294.953C34.89 295.497 34.146 295.769 33.186 295.769C32.546 295.769 31.99 295.661 31.518 295.445C31.046 295.221 30.682 294.913 30.426 294.521C30.17 294.129 30.03 293.677 30.006 293.165H32.01C32.058 293.413 32.174 293.621 32.358 293.789C32.542 293.949 32.794 294.029 33.114 294.029C33.49 294.029 33.77 293.909 33.954 293.669C34.138 293.429 34.23 293.109 34.23 292.709C34.23 292.317 34.134 292.017 33.942 291.809C33.75 291.601 33.47 291.497 33.102 291.497C32.83 291.497 32.606 291.565 32.43 291.701C32.254 291.829 32.138 292.001 32.082 292.217H30.102V286.997H35.706V288.797Z"
      fill="#4A5568"
    />
    <g clipPath="url(#clip1_1168_39633)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.5718 5.76862C72.9901 5.76862 76.5718 9.35033 76.5718 13.7686L76.5718 98.1686C76.5718 100.961 75.1407 103.42 72.9718 104.851V107.886C75.1407 109.317 76.5718 111.776 76.5718 114.569L76.5718 257.769C76.5718 262.187 72.9901 265.769 68.5718 265.769C64.1535 265.769 60.5718 262.187 60.5718 257.769L60.5718 114.569C60.5718 111.776 62.0029 109.317 64.1718 107.886V104.851C62.0029 103.42 60.5718 100.961 60.5718 98.1686L60.5718 13.7686C60.5718 9.35034 64.1535 5.76862 68.5718 5.76862Z"
        fill="#F7FAFC"
      />
      <rect
        x="60.5718"
        y="18.5686"
        width="15.9997"
        height="7.2"
        fill="#E2E8F0"
      />
      <rect
        x="60.5718"
        y="33.7686"
        width="15.9997"
        height="20"
        fill="#E2E8F0"
      />
      <rect x="60.5718" y="68.9686" width="16" height="6.4" fill="#E2E8F0" />
      <mask
        id="mask1_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="60"
        y="97"
        width="17"
        height="18"
      >
        <path
          d="M76.5716 97.7686C76.5716 99.1216 75.2281 103.918 73.1717 104.642V107.696C75.2281 108.419 76.5716 113.216 76.5716 114.569L60.5718 114.569C60.5718 113.216 61.9154 108.419 63.9718 107.696V104.642C61.9154 103.918 60.5718 99.1217 60.5718 97.7686H76.5716Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask1_1168_39633)">
        <path
          d="M60.5718 102.169H76.5718V110.169H60.5718V102.169Z"
          fill="#EDF2F7"
        />
      </g>
      <rect
        x="60.5718"
        y="83.3686"
        width="15.9997"
        height="11.6"
        fill="#E2E8F0"
      />
      <rect x="60.5718" y="115.769" width="15.9997" height="6" fill="#E2E8F0" />
      <rect x="60.5718" y="126.969" width="16" height="28" fill="#E2E8F0" />
      <rect x="60.5718" y="158.569" width="16" height="8.8" fill="#E2E8F0" />
      <rect x="60.5718" y="180.569" width="16" height="12" fill="#E2E8F0" />
      <rect x="60.5718" y="194.969" width="16" height="12.8" fill="#E2E8F0" />
      <rect x="60.5718" y="212.169" width="16" height="4" fill="#E2E8F0" />
      <rect x="60.5718" y="219.769" width="16" height="16" fill="#E2E8F0" />
      <rect x="60.5718" y="249.369" width="16" height="8" fill="#E2E8F0" />
    </g>
    <path
      d="M69.6235 277.373C69.5595 277.077 69.4475 276.857 69.2875 276.713C69.1275 276.561 68.8995 276.485 68.6035 276.485C68.1475 276.485 67.8195 276.685 67.6195 277.085C67.4195 277.477 67.3155 278.101 67.3075 278.957C67.4835 278.677 67.7355 278.457 68.0635 278.297C68.3995 278.137 68.7675 278.057 69.1675 278.057C69.9515 278.057 70.5795 278.305 71.0515 278.801C71.5315 279.297 71.7715 279.989 71.7715 280.877C71.7715 281.461 71.6515 281.973 71.4115 282.413C71.1795 282.853 70.8355 283.197 70.3795 283.445C69.9315 283.693 69.3995 283.817 68.7835 283.817C67.5515 283.817 66.6955 283.433 66.2155 282.665C65.7355 281.889 65.4955 280.777 65.4955 279.329C65.4955 277.809 65.7475 276.681 66.2515 275.945C66.7635 275.201 67.5795 274.829 68.6995 274.829C69.2995 274.829 69.8035 274.949 70.2115 275.189C70.6275 275.421 70.9395 275.729 71.1475 276.113C71.3635 276.497 71.4915 276.917 71.5315 277.373H69.6235ZM68.6755 279.677C68.3315 279.677 68.0435 279.781 67.8115 279.989C67.5875 280.189 67.4755 280.477 67.4755 280.853C67.4755 281.237 67.5795 281.537 67.7875 281.753C68.0035 281.969 68.3075 282.077 68.6995 282.077C69.0515 282.077 69.3275 281.973 69.5275 281.765C69.7355 281.549 69.8395 281.257 69.8395 280.889C69.8395 280.513 69.7395 280.217 69.5395 280.001C69.3395 279.785 69.0515 279.677 68.6755 279.677Z"
      fill="#4A5568"
    />
    <g clipPath="url(#clip2_1168_39633)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.243 5.76862C108.661 5.76862 112.243 9.35033 112.243 13.7686L112.243 86.5686C112.243 89.3615 110.812 91.82 108.643 93.251V95.8862C110.812 97.3172 112.243 99.7758 112.243 102.569L112.243 248.569C112.243 252.987 108.661 256.569 104.243 256.569C99.8249 256.569 96.2432 252.987 96.2432 248.569L96.2432 102.569C96.2432 99.7758 97.6743 97.3172 99.8432 95.8862V93.251C97.6743 91.82 96.2432 89.3615 96.2432 86.5686L96.2432 13.7686C96.2432 9.35033 99.8249 5.76862 104.243 5.76862Z"
        fill="#F7FAFC"
      />
      <rect
        x="96.2432"
        y="18.5686"
        width="15.9997"
        height="21.6"
        fill="#E2E8F0"
      />
      <rect x="96.2432" y="44.9686" width="15.9997" height="4" fill="#E2E8F0" />
      <rect x="96.2432" y="54.5686" width="16" height="12" fill="#E2E8F0" />
      <mask
        id="mask2_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="96"
        y="85"
        width="17"
        height="18"
      >
        <path
          d="M112.243 85.3686C112.243 86.7216 110.899 91.5177 108.843 92.2416V95.2956C110.899 96.0194 112.243 100.816 112.243 102.169L96.2432 102.169C96.2432 100.816 97.5868 96.0194 99.6432 95.2955V92.2417C97.5867 91.5178 96.2432 86.7216 96.2432 85.3686H112.243Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask2_1168_39633)">
        <path
          d="M96.2432 89.7686H112.243V97.7686H96.2432V89.7686Z"
          fill="#EDF2F7"
        />
      </g>
      <rect
        x="96.2432"
        y="72.1686"
        width="15.9997"
        height="11.6"
        fill="#E2E8F0"
      />
      <rect x="96.2432" y="106.169" width="15.9997" height="6" fill="#E2E8F0" />
      <rect x="96.2432" y="130.569" width="16" height="16" fill="#E2E8F0" />
      <rect x="96.2432" y="149.369" width="16" height="8" fill="#E2E8F0" />
      <rect x="96.2432" y="174.569" width="16" height="9.2" fill="#E2E8F0" />
      <rect x="96.2432" y="187.769" width="16" height="20" fill="#E2E8F0" />
      <rect x="96.2432" y="218.169" width="16" height="22" fill="#E2E8F0" />
    </g>
    <path
      d="M107.164 267.345L104.152 274.569H102.052L105.1 267.573H101.368V265.821H107.164V267.345Z"
      fill="#4A5568"
    />
    <g clipPath="url(#clip3_1168_39633)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M139.914 5.76862C144.333 5.76862 147.914 9.35033 147.914 13.7686L147.914 77.7686C147.914 82.1869 144.333 85.7686 139.914 85.7686C135.496 85.7686 131.914 82.1869 131.914 77.7686L131.914 13.7686C131.914 9.35033 135.496 5.76862 139.914 5.76862ZM139.915 85.7686C144.333 85.7686 147.915 89.3503 147.915 93.7686L147.915 193.769C147.915 198.187 144.333 201.769 139.915 201.769C135.497 201.769 131.915 198.187 131.915 193.769L131.915 93.7686C131.915 89.3503 135.497 85.7686 139.915 85.7686Z"
        fill="#F7FAFC"
      />
      <rect
        x="131.914"
        y="13.3686"
        width="15.9997"
        height="5.2"
        fill="#E2E8F0"
      />
      <rect x="131.914" y="26.9686" width="15.9997" height="4" fill="#E2E8F0" />
      <rect x="131.914" y="34.5686" width="16" height="20" fill="#E2E8F0" />
      <mask
        id="mask3_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="131"
        y="77"
        width="17"
        height="19"
      >
        <path
          d="M147.914 77.3686C147.914 78.7216 146.571 83.5177 144.514 84.2416V87.2956C146.571 88.0194 147.914 93.9156 147.914 95.2686L131.914 95.2686C131.914 93.9156 133.258 88.0194 135.314 87.2955V84.2417C133.258 83.5178 131.914 78.7216 131.914 77.3686H147.914Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask3_1168_39633)">
        <path
          d="M131.914 81.7686H147.914V89.7686H131.914V81.7686Z"
          fill="#EDF2F7"
        />
      </g>
      <rect
        x="131.914"
        y="58.1686"
        width="15.9997"
        height="11.6"
        fill="#E2E8F0"
      />
      <path
        d="M131.914 78.7686H147.914C147.914 80.9778 146.123 82.7686 143.914 82.7686H135.914C133.705 82.7686 131.914 80.9778 131.914 78.7686Z"
        fill="#E2E8F0"
      />
      <path
        d="M131.915 94.7686C131.915 90.3503 135.497 86.7686 139.915 86.7686C144.333 86.7686 147.915 90.3503 147.915 94.7686V96.7686H131.915V94.7686Z"
        fill="#E2E8F0"
      />
      <rect x="131.914" y="108.169" width="15.9997" height="4" fill="#E2E8F0" />
      <rect x="131.914" y="115.769" width="16" height="4" fill="#E2E8F0" />
      <rect x="131.914" y="124.169" width="16" height="16.8" fill="#E2E8F0" />
      <rect x="131.914" y="145.369" width="16" height="6.8" fill="#E2E8F0" />
      <rect x="131.914" y="153.769" width="16" height="6.8" fill="#E2E8F0" />
      <rect x="131.914" y="165.769" width="16" height="5.2" fill="#E2E8F0" />
      <rect x="131.914" y="184.569" width="16" height="8" fill="#E2E8F0" />
    </g>
    <path
      d="M135.727 213.317V211.409H139.051V220.169H136.915V213.317H135.727ZM140.238 213.317V211.409H143.562V220.169H141.426V213.317H140.238Z"
      fill="#4A5568"
    />
    <g clipPath="url(#clip4_1168_39633)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M175.586 5.75189C180.004 5.75189 183.586 9.33361 183.586 13.7519L183.586 55.3519C183.586 59.7702 180.004 63.3519 175.586 63.3519C171.168 63.3519 167.586 59.7702 167.586 55.3519L167.586 13.7519C167.586 9.33361 171.168 5.75189 175.586 5.75189ZM167.586 72.9519L167.586 167.352C167.586 171.77 171.168 175.352 175.586 175.352C180.004 175.352 183.586 171.77 183.586 167.352L183.586 72.9519V66.5519H181.665C180.198 64.838 178.019 63.7519 175.586 63.7519C173.153 63.7519 170.973 64.838 169.506 66.5519H167.586V72.9519Z"
        fill="#F7FAFC"
      />
      <rect
        x="167.586"
        y="17.3519"
        width="15.9997"
        height="4.4"
        fill="#E2E8F0"
      />
      <rect x="167.586" y="24.1519" width="15.9997" height="8" fill="#E2E8F0" />
      <rect x="167.586" y="34.1519" width="16" height="5.2" fill="#E2E8F0" />
      <mask
        id="mask4_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="167"
        y="60"
        width="17"
        height="8"
      >
        <path
          d="M183.586 60.1519C183.586 61.5049 182.242 61.1011 180.186 61.8249V64.8789C182.242 65.6028 183.586 65.9989 183.586 67.3519L167.586 67.3519C167.586 65.9989 168.929 65.6027 170.986 64.8789V61.825C168.929 61.1011 167.586 61.505 167.586 60.1519H183.586Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask4_1168_39633)">
        <path
          d="M167.586 60.1519H183.586V66.9519H167.586V60.1519Z"
          fill="#EDF2F7"
        />
      </g>
      <rect
        x="167.586"
        y="49.3519"
        width="15.9997"
        height="10.8"
        fill="#E2E8F0"
      />
      <path
        d="M167.586 77.7519H183.586V81.3519H167.586V77.7519Z"
        fill="#E2E8F0"
      />
      <path
        d="M167.586 84.5519H183.586V95.3519H167.586V84.5519Z"
        fill="#E2E8F0"
      />
      <rect
        x="167.586"
        y="102.552"
        width="15.9997"
        height="7.6"
        fill="#E2E8F0"
      />
      <rect x="167.586" y="112.552" width="16" height="13.2" fill="#E2E8F0" />
      <rect x="167.586" y="134.552" width="16" height="13.2" fill="#E2E8F0" />
      <rect x="167.586" y="156.152" width="16" height="5.2" fill="#E2E8F0" />
      <rect x="167.586" y="166.952" width="16" height="3.2" fill="#E2E8F0" />
    </g>
    <path
      d="M170.226 186.5V184.592H173.55V193.352H171.414V186.5H170.226ZM174.882 191.708C175.154 191.492 175.278 191.392 175.254 191.408C176.038 190.76 176.654 190.228 177.102 189.812C177.558 189.396 177.942 188.96 178.254 188.504C178.566 188.048 178.722 187.604 178.722 187.172C178.722 186.844 178.646 186.588 178.494 186.404C178.342 186.22 178.114 186.128 177.81 186.128C177.506 186.128 177.266 186.244 177.09 186.476C176.922 186.7 176.838 187.02 176.838 187.436H174.858C174.874 186.756 175.018 186.188 175.29 185.732C175.57 185.276 175.934 184.94 176.382 184.724C176.838 184.508 177.342 184.4 177.894 184.4C178.846 184.4 179.562 184.644 180.042 185.132C180.53 185.62 180.774 186.256 180.774 187.04C180.774 187.896 180.482 188.692 179.898 189.428C179.314 190.156 178.57 190.868 177.666 191.564H180.906V193.232H174.882V191.708Z"
      fill="#4A5568"
    />
    <g clipPath="url(#clip5_1168_39633)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M211.258 5.75189C215.676 5.75189 219.258 9.33361 219.258 13.7519L219.258 25.7519C219.258 30.1702 215.676 33.7519 211.258 33.7519C206.84 33.7519 203.258 30.1702 203.258 25.7519L203.258 13.7519C203.258 9.33361 206.84 5.75189 211.258 5.75189ZM211.258 33.7519C215.676 33.7519 219.258 37.3336 219.258 41.7519L219.258 66.5519V72.9519L219.258 149.752C219.258 154.17 215.676 157.752 211.258 157.752C206.84 157.752 203.258 154.17 203.258 149.752L203.258 72.9519V66.5519L203.258 41.7519C203.258 37.3336 206.84 33.7519 211.258 33.7519Z"
        fill="#F7FAFC"
      />
      <rect
        x="203.258"
        y="14.9519"
        width="15.9997"
        height="1.2"
        fill="#E2E8F0"
      />
      <rect
        x="203.258"
        y="16.5519"
        width="15.9997"
        height="1.2"
        fill="#E2E8F0"
      />
      <path
        d="M203.258 49.3519H219.258V61.3519H203.258V49.3519Z"
        fill="#E2E8F0"
      />
      <path
        d="M203.258 70.5519H219.258V89.7519H203.258V70.5519Z"
        fill="#E2E8F0"
      />
      <rect
        x="203.258"
        y="102.552"
        width="15.9997"
        height="7.6"
        fill="#E2E8F0"
      />
      <rect x="203.258" y="114.952" width="16" height="6" fill="#E2E8F0" />
      <rect x="203.258" y="128.152" width="16" height="12.4" fill="#E2E8F0" />
      <rect x="203.258" y="146.952" width="16" height="4.8" fill="#E2E8F0" />
      <mask
        id="mask5_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="203"
        y="5"
        width="17"
        height="10"
      >
        <rect
          x="203.258"
          y="5.75189"
          width="15.9997"
          height="9.2"
          rx="4.6"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask5_1168_39633)">
        <rect
          width="18.2409"
          height="18.3499"
          transform="translate(198.234 11.2206) rotate(-42.4793)"
          fill="#E2E8F0"
        />
        <line
          x1="212.607"
          y1="22.9397"
          x2="200.215"
          y2="9.40625"
          stroke="#CBD5E0"
        />
        <line
          x1="214.358"
          y1="21.3368"
          x2="201.966"
          y2="7.80334"
          stroke="#CBD5E0"
        />
        <line
          x1="216.108"
          y1="19.734"
          x2="203.716"
          y2="6.2005"
          stroke="#CBD5E0"
        />
        <line
          x1="217.859"
          y1="18.1311"
          x2="205.467"
          y2="4.59765"
          stroke="#CBD5E0"
        />
        <line
          x1="219.609"
          y1="16.5282"
          x2="207.217"
          y2="2.99475"
          stroke="#CBD5E0"
        />
        <line
          x1="221.36"
          y1="14.9254"
          x2="208.968"
          y2="1.3919"
          stroke="#CBD5E0"
        />
      </g>
      <mask
        id="mask6_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="203"
        y="17"
        width="17"
        height="16"
      >
        <rect
          x="203.258"
          y="17.7519"
          width="15.9997"
          height="14.8"
          rx="7.4"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask6_1168_39633)">
        <rect
          width="23.9517"
          height="25.051"
          transform="matrix(0.561672 -0.82736 0.494677 0.869077 198.234 26.5495)"
          fill="#E2E8F0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 212.683 45.2904)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 214.551 42.5392)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 216.418 39.788)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 218.286 37.0367)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 220.154 34.2856)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="25.051"
          y2="-0.5"
          transform="matrix(-0.494677 -0.869077 0.561672 -0.82736 222.022 31.5344)"
          stroke="#CBD5E0"
        />
      </g>
      <mask
        id="mask7_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="203"
        y="29"
        width="17"
        height="10"
      >
        <path
          d="M219.258 29.3519C219.258 31.1559 217.914 30.6174 215.858 31.5825V35.6545C217.914 36.6197 219.258 37.1478 219.258 38.9519L203.258 38.9519C203.258 37.1478 204.601 36.6196 206.658 35.6545V31.5826C204.601 30.6175 203.258 31.1559 203.258 29.3519H219.258Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask7_1168_39633)">
        <path
          d="M203.258 29.3519H219.258V38.4185H203.258V29.3519Z"
          fill="#EDF2F7"
        />
      </g>
    </g>
    <path
      d="M205.265 168.9V166.992H208.589V175.752H206.453V168.9H205.265ZM210.041 174.192V172.536L213.833 167.112H216.125V172.416H217.109V174.192H216.125V175.752H214.073V174.192H210.041ZM214.217 169.368L212.201 172.416H214.217V169.368Z"
      fill="#4A5568"
    />
    <g clipPath="url(#clip6_1168_39633)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M318.272 5.75189C322.69 5.75189 326.272 9.33361 326.272 13.7519L326.272 43.7519V50.1519H324.955C323.524 52.3208 321.065 53.7519 318.272 53.7519C315.479 53.7519 313.021 52.3208 311.59 50.1519H310.272V45.7519V43.7519L310.272 13.7519C310.272 9.33361 313.854 5.75189 318.272 5.75189ZM318.272 53.7519C322.69 53.7519 326.272 57.3336 326.272 61.7519L326.272 93.7519C326.272 98.1702 322.69 101.752 318.272 101.752C313.854 101.752 310.272 98.1702 310.272 93.7519L310.272 61.7519C310.272 57.3336 313.854 53.7519 318.272 53.7519Z"
        fill="#F7FAFC"
      />
      <rect x="310.272" y="20.9519" width="16" height="18.4" fill="#E2E8F0" />
      <mask
        id="mask8_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="310"
        y="48"
        width="17"
        height="14"
      >
        <path
          d="M326.272 48.1519C326.272 49.5049 324.929 51.1011 322.872 51.8249V54.8789C324.929 55.6028 326.272 59.7989 326.272 61.1519L310.272 61.1519C310.272 59.7989 311.616 55.6027 313.672 54.8789V51.825C311.616 51.1011 310.272 49.505 310.272 48.1519H326.272Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask8_1168_39633)">
        <path
          d="M310.272 50.1519H326.272V56.9519H310.272V50.1519Z"
          fill="#EDF2F7"
        />
      </g>
      <path
        d="M310.272 68.5519H326.272V76.9519H310.272V68.5519Z"
        fill="#E2E8F0"
      />
      <path
        d="M310.272 82.5519H326.272V90.9519H310.272V82.5519Z"
        fill="#E2E8F0"
      />
    </g>
    <path
      d="M311.398 118.108C311.67 117.892 311.794 117.792 311.77 117.808C312.554 117.16 313.17 116.628 313.618 116.212C314.074 115.796 314.458 115.36 314.77 114.904C315.082 114.448 315.238 114.004 315.238 113.572C315.238 113.244 315.162 112.988 315.01 112.804C314.858 112.62 314.63 112.528 314.326 112.528C314.022 112.528 313.782 112.644 313.606 112.876C313.438 113.1 313.354 113.42 313.354 113.836H311.374C311.39 113.156 311.534 112.588 311.806 112.132C312.086 111.676 312.45 111.34 312.898 111.124C313.354 110.908 313.858 110.8 314.41 110.8C315.362 110.8 316.078 111.044 316.558 111.532C317.046 112.02 317.29 112.656 317.29 113.44C317.29 114.296 316.998 115.092 316.414 115.828C315.83 116.556 315.086 117.268 314.182 117.964H317.422V119.632H311.398V118.108ZM318.326 115.252C318.326 113.876 318.59 112.792 319.118 112C319.654 111.208 320.514 110.812 321.698 110.812C322.882 110.812 323.738 111.208 324.266 112C324.802 112.792 325.07 113.876 325.07 115.252C325.07 116.644 324.802 117.736 324.266 118.528C323.738 119.32 322.882 119.716 321.698 119.716C320.514 119.716 319.654 119.32 319.118 118.528C318.59 117.736 318.326 116.644 318.326 115.252ZM323.054 115.252C323.054 114.444 322.966 113.824 322.79 113.392C322.614 112.952 322.25 112.732 321.698 112.732C321.146 112.732 320.782 112.952 320.606 113.392C320.43 113.824 320.342 114.444 320.342 115.252C320.342 115.796 320.374 116.248 320.438 116.608C320.502 116.96 320.63 117.248 320.822 117.472C321.022 117.688 321.314 117.796 321.698 117.796C322.082 117.796 322.37 117.688 322.562 117.472C322.762 117.248 322.894 116.96 322.958 116.608C323.022 116.248 323.054 115.796 323.054 115.252Z"
      fill="#4A5568"
    />
    <g clipPath="url(#clip7_1168_39633)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M282.601 5.75189C287.019 5.75189 290.601 9.33361 290.601 13.7519L290.601 47.7519V54.1519H289.283C288.405 55.4835 287.139 56.5369 285.646 57.1519C288.554 58.3498 290.601 61.2118 290.601 64.5519L290.601 123.352C290.601 127.77 287.019 131.352 282.601 131.352C278.182 131.352 274.601 127.77 274.601 123.352L274.601 64.5519C274.601 61.2118 276.648 58.3498 279.555 57.1519C278.063 56.5369 276.797 55.4835 275.918 54.1519H274.601V47.7519L274.601 13.7519C274.601 9.33361 278.182 5.75189 282.601 5.75189Z"
        fill="#F7FAFC"
      />
      <rect
        x="274.601"
        y="17.3519"
        width="15.9997"
        height="4.4"
        fill="#E2E8F0"
      />
      <rect x="274.601" y="28.5519" width="16" height="12.4" fill="#E2E8F0" />
      <mask
        id="mask9_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="274"
        y="57"
        width="17"
        height="10"
      >
        <rect
          x="274.601"
          y="57.7519"
          width="15.9997"
          height="9.2"
          rx="4.6"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask9_1168_39633)">
        <rect
          width="18.2409"
          height="18.3499"
          transform="translate(269.576 63.2206) rotate(-42.4793)"
          fill="#E2E8F0"
        />
        <line
          x1="283.95"
          y1="74.9397"
          x2="271.558"
          y2="61.4062"
          stroke="#CBD5E0"
        />
        <line
          x1="285.701"
          y1="73.3368"
          x2="273.309"
          y2="59.8033"
          stroke="#CBD5E0"
        />
        <line
          x1="287.451"
          y1="71.734"
          x2="275.059"
          y2="58.2005"
          stroke="#CBD5E0"
        />
        <line
          x1="289.202"
          y1="70.1311"
          x2="276.809"
          y2="56.5977"
          stroke="#CBD5E0"
        />
        <line
          x1="290.952"
          y1="68.5282"
          x2="278.56"
          y2="54.9947"
          stroke="#CBD5E0"
        />
        <line
          x1="292.703"
          y1="66.9254"
          x2="280.31"
          y2="53.3919"
          stroke="#CBD5E0"
        />
      </g>
      <mask
        id="mask10_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="274"
        y="52"
        width="17"
        height="9"
      >
        <path
          d="M290.601 52.9519C290.601 54.3049 289.257 53.901 287.201 54.6249V57.6789C289.257 58.4028 290.601 58.7989 290.601 60.1519L274.601 60.1519C274.601 58.7989 275.944 58.4027 278.001 57.6788V54.625C275.944 53.9011 274.601 54.305 274.601 52.9519H290.601Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask10_1168_39633)">
        <path
          d="M274.601 52.9519H290.601V59.7519H274.601V52.9519Z"
          fill="#EDF2F7"
        />
      </g>
      <path
        d="M274.601 77.7519H290.6V81.3519H274.601V77.7519Z"
        fill="#E2E8F0"
      />
      <path
        d="M274.601 90.5519H290.6V101.352H274.601V90.5519Z"
        fill="#E2E8F0"
      />
      <rect x="274.601" y="116.152" width="16" height="9.6" fill="#E2E8F0" />
    </g>
    <path
      d="M276.849 142.5V140.592H280.173V149.352H278.037V142.5H276.849ZM285.908 142.956C285.844 142.66 285.732 142.44 285.572 142.296C285.412 142.144 285.184 142.068 284.888 142.068C284.432 142.068 284.104 142.268 283.904 142.668C283.704 143.06 283.6 143.684 283.592 144.54C283.768 144.26 284.02 144.04 284.348 143.88C284.684 143.72 285.052 143.64 285.452 143.64C286.236 143.64 286.864 143.888 287.336 144.384C287.816 144.88 288.056 145.572 288.056 146.46C288.056 147.044 287.936 147.556 287.696 147.996C287.464 148.436 287.12 148.78 286.664 149.028C286.216 149.276 285.684 149.4 285.068 149.4C283.836 149.4 282.98 149.016 282.5 148.248C282.02 147.472 281.78 146.36 281.78 144.912C281.78 143.392 282.032 142.264 282.536 141.528C283.048 140.784 283.864 140.412 284.984 140.412C285.584 140.412 286.088 140.532 286.496 140.772C286.912 141.004 287.224 141.312 287.432 141.696C287.648 142.08 287.776 142.5 287.816 142.956H285.908ZM284.96 145.26C284.616 145.26 284.328 145.364 284.096 145.572C283.872 145.772 283.76 146.06 283.76 146.436C283.76 146.82 283.864 147.12 284.072 147.336C284.288 147.552 284.592 147.66 284.984 147.66C285.336 147.66 285.612 147.556 285.812 147.348C286.02 147.132 286.124 146.84 286.124 146.472C286.124 146.096 286.024 145.8 285.824 145.584C285.624 145.368 285.336 145.26 284.96 145.26Z"
      fill="#4A5568"
    />
    <rect
      x="0.671143"
      y="11.5515"
      width="44"
      height="32.0685"
      rx="16.0343"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M7.24211 30.6417C6.83144 30.6417 6.46344 30.575 6.13811 30.4417C5.81278 30.3084 5.55144 30.111 5.35411 29.8497C5.16211 29.5884 5.06078 29.2737 5.05011 28.9057H6.50611C6.52744 29.1137 6.59944 29.2737 6.72211 29.3857C6.84478 29.4924 7.00478 29.5457 7.20211 29.5457C7.40478 29.5457 7.56478 29.5004 7.68211 29.4097C7.79944 29.3137 7.85811 29.183 7.85811 29.0177C7.85811 28.879 7.81011 28.7644 7.71411 28.6737C7.62344 28.583 7.50878 28.5084 7.37011 28.4497C7.23678 28.391 7.04478 28.3244 6.79411 28.2497C6.43144 28.1377 6.13544 28.0257 5.90611 27.9137C5.67678 27.8017 5.47944 27.6364 5.31411 27.4177C5.14878 27.199 5.06611 26.9137 5.06611 26.5617C5.06611 26.039 5.25544 25.631 5.63411 25.3377C6.01278 25.039 6.50611 24.8897 7.11411 24.8897C7.73278 24.8897 8.23144 25.039 8.61011 25.3377C8.98878 25.631 9.19144 26.0417 9.21811 26.5697H7.73811C7.72744 26.3884 7.66078 26.247 7.53811 26.1457C7.41544 26.039 7.25811 25.9857 7.06611 25.9857C6.90078 25.9857 6.76744 26.031 6.66611 26.1217C6.56478 26.207 6.51411 26.3324 6.51411 26.4977C6.51411 26.679 6.59944 26.8204 6.77011 26.9217C6.94078 27.023 7.20744 27.1324 7.57011 27.2497C7.93278 27.3724 8.22611 27.4897 8.45011 27.6017C8.67944 27.7137 8.87678 27.8764 9.04211 28.0897C9.20744 28.303 9.29011 28.5777 9.29011 28.9137C9.29011 29.2337 9.20744 29.5244 9.04211 29.7857C8.88211 30.047 8.64744 30.255 8.33811 30.4097C8.02878 30.5644 7.66344 30.6417 7.24211 30.6417ZM11.5 29.5297H13.292V30.5857H10.132V24.9697H11.5V29.5297ZM13.7125 27.7697C13.7125 27.215 13.8325 26.7217 14.0725 26.2897C14.3125 25.8524 14.6458 25.5137 15.0725 25.2737C15.5045 25.0284 15.9925 24.9057 16.5365 24.9057C17.2032 24.9057 17.7738 25.0817 18.2485 25.4337C18.7232 25.7857 19.0405 26.2657 19.2005 26.8737H17.6965C17.5845 26.639 17.4245 26.4604 17.2165 26.3377C17.0138 26.215 16.7818 26.1537 16.5205 26.1537C16.0992 26.1537 15.7578 26.3004 15.4965 26.5937C15.2352 26.887 15.1045 27.279 15.1045 27.7697C15.1045 28.2604 15.2352 28.6524 15.4965 28.9457C15.7578 29.239 16.0992 29.3857 16.5205 29.3857C16.7818 29.3857 17.0138 29.3244 17.2165 29.2017C17.4245 29.079 17.5845 28.9004 17.6965 28.6657H19.2005C19.0405 29.2737 18.7232 29.7537 18.2485 30.1057C17.7738 30.4524 17.2032 30.6257 16.5365 30.6257C15.9925 30.6257 15.5045 30.5057 15.0725 30.2657C14.6458 30.0204 14.3125 29.6817 14.0725 29.2497C13.8325 28.8177 13.7125 28.3244 13.7125 27.7697ZM19.9342 29.5457V28.4417L22.4622 24.8257H23.9902V28.3617H24.6462V29.5457H23.9902V30.5857H22.6222V29.5457H19.9342ZM22.7182 26.3297L21.3742 28.3617H22.7182V26.3297ZM29.4283 25.9377H26.9323V27.0417C27.039 26.9244 27.1883 26.8284 27.3803 26.7537C27.5723 26.679 27.7803 26.6417 28.0043 26.6417C28.4043 26.6417 28.735 26.7324 28.9963 26.9137C29.263 27.095 29.4576 27.3297 29.5803 27.6177C29.703 27.9057 29.7643 28.2177 29.7643 28.5537C29.7643 29.1777 29.5883 29.6737 29.2363 30.0417C28.8843 30.4044 28.3883 30.5857 27.7483 30.5857C27.3216 30.5857 26.951 30.5137 26.6363 30.3697C26.3216 30.2204 26.079 30.015 25.9083 29.7537C25.7376 29.4924 25.6443 29.191 25.6283 28.8497H26.9643C26.9963 29.015 27.0736 29.1537 27.1963 29.2657C27.319 29.3724 27.487 29.4257 27.7003 29.4257C27.951 29.4257 28.1376 29.3457 28.2603 29.1857C28.383 29.0257 28.4443 28.8124 28.4443 28.5457C28.4443 28.2844 28.3803 28.0844 28.2523 27.9457C28.1243 27.807 27.9376 27.7377 27.6923 27.7377C27.511 27.7377 27.3616 27.783 27.2443 27.8737C27.127 27.959 27.0496 28.0737 27.0123 28.2177H25.6923V24.7377H29.4283V25.9377ZM34.1514 29.5937H32.0554L31.7194 30.5857H30.2874L32.3194 24.9697H33.9034L35.9354 30.5857H34.4874L34.1514 29.5937ZM33.7994 28.5377L33.1034 26.4817L32.4154 28.5377H33.7994ZM36.3699 29.4897C36.5512 29.3457 36.6339 29.279 36.6179 29.2897C37.1405 28.8577 37.5512 28.503 37.8499 28.2257C38.1539 27.9484 38.4099 27.6577 38.6179 27.3537C38.8259 27.0497 38.9299 26.7537 38.9299 26.4657C38.9299 26.247 38.8792 26.0764 38.7779 25.9537C38.6765 25.831 38.5245 25.7697 38.3219 25.7697C38.1192 25.7697 37.9592 25.847 37.8419 26.0017C37.7299 26.151 37.6739 26.3644 37.6739 26.6417H36.3539C36.3645 26.1884 36.4605 25.8097 36.6419 25.5057C36.8285 25.2017 37.0712 24.9777 37.3699 24.8337C37.6739 24.6897 38.0099 24.6177 38.3779 24.6177C39.0125 24.6177 39.4899 24.7804 39.8099 25.1057C40.1352 25.431 40.2979 25.855 40.2979 26.3777C40.2979 26.9484 40.1032 27.479 39.7139 27.9697C39.3245 28.455 38.8285 28.9297 38.2259 29.3937H40.3859V30.5057H36.3699V29.4897Z"
      fill="white"
    />
    <rect
      x="51"
      y="32"
      width="26"
      height="19.9771"
      rx="9.98856"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M57.1804 39.3726V44.9886H55.8124V39.3726H57.1804ZM61.0358 44.9886L59.8678 42.8686H59.5398V44.9886H58.1718V39.3726H60.4678C60.9104 39.3726 61.2864 39.4499 61.5958 39.6046C61.9104 39.7593 62.1451 39.9726 62.2998 40.2446C62.4544 40.5113 62.5318 40.8099 62.5318 41.1406C62.5318 41.5139 62.4251 41.8473 62.2118 42.1406C62.0038 42.4339 61.6944 42.6419 61.2838 42.7646L62.5798 44.9886H61.0358ZM59.5398 41.9006H60.3878C60.6384 41.9006 60.8251 41.8393 60.9478 41.7166C61.0758 41.5939 61.1398 41.4206 61.1398 41.1966C61.1398 40.9833 61.0758 40.8153 60.9478 40.6926C60.8251 40.5699 60.6384 40.5086 60.3878 40.5086H59.5398V41.9006ZM67.0465 39.3726V40.4686H64.7585V41.6526H66.4705V42.7166H64.7585V44.9886H63.3905V39.3726H67.0465ZM67.6615 43.9486V42.8446L70.1895 39.2286H71.7175V42.7646H72.3735V43.9486H71.7175V44.9886H70.3495V43.9486H67.6615ZM70.4455 40.7326L69.1015 42.7646H70.4455V40.7326Z"
      fill="white"
    />
    <rect
      x="69.6127"
      y="0.494751"
      width="35"
      height="26.2857"
      rx="13.1428"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M75.4767 12.1176V13.2536H77.3087V14.3096H75.4767V15.5416H77.5487V16.6376H74.1087V11.0216H77.5487V12.1176H75.4767ZM81.8768 16.6376L80.7328 14.9176L79.7248 16.6376H78.1728L79.9728 13.7816L78.1328 11.0216H79.7248L80.8528 12.7176L81.8448 11.0216H83.3968L81.6128 13.8536L83.4688 16.6376H81.8768ZM86.8115 16.6936C86.2835 16.6936 85.7982 16.5709 85.3555 16.3256C84.9182 16.0802 84.5689 15.7389 84.3075 15.3016C84.0515 14.8589 83.9235 14.3629 83.9235 13.8136C83.9235 13.2642 84.0515 12.7709 84.3075 12.3336C84.5689 11.8962 84.9182 11.5549 85.3555 11.3096C85.7982 11.0642 86.2835 10.9416 86.8115 10.9416C87.3395 10.9416 87.8222 11.0642 88.2595 11.3096C88.7022 11.5549 89.0489 11.8962 89.2995 12.3336C89.5555 12.7709 89.6835 13.2642 89.6835 13.8136C89.6835 14.3629 89.5555 14.8589 89.2995 15.3016C89.0435 15.7389 88.6969 16.0802 88.2595 16.3256C87.8222 16.5709 87.3395 16.6936 86.8115 16.6936ZM86.8115 15.4456C87.2595 15.4456 87.6169 15.2962 87.8835 14.9976C88.1555 14.6989 88.2915 14.3042 88.2915 13.8136C88.2915 13.3176 88.1555 12.9229 87.8835 12.6296C87.6169 12.3309 87.2595 12.1816 86.8115 12.1816C86.3582 12.1816 85.9955 12.3282 85.7235 12.6216C85.4569 12.9149 85.3235 13.3122 85.3235 13.8136C85.3235 14.3096 85.4569 14.7069 85.7235 15.0056C85.9955 15.2989 86.3582 15.4456 86.8115 15.4456ZM90.2126 13.8216C90.2126 13.2669 90.3326 12.7736 90.5726 12.3416C90.8126 11.9042 91.1459 11.5656 91.5726 11.3256C92.0046 11.0802 92.4926 10.9576 93.0366 10.9576C93.7033 10.9576 94.2739 11.1336 94.7486 11.4856C95.2233 11.8376 95.5406 12.3176 95.7006 12.9256H94.1966C94.0846 12.6909 93.9246 12.5122 93.7166 12.3896C93.5139 12.2669 93.2819 12.2056 93.0206 12.2056C92.5993 12.2056 92.2579 12.3522 91.9966 12.6456C91.7353 12.9389 91.6046 13.3309 91.6046 13.8216C91.6046 14.3122 91.7353 14.7042 91.9966 14.9976C92.2579 15.2909 92.5993 15.4376 93.0206 15.4376C93.2819 15.4376 93.5139 15.3762 93.7166 15.2536C93.9246 15.1309 94.0846 14.9522 94.1966 14.7176H95.7006C95.5406 15.3256 95.2233 15.8056 94.7486 16.1576C94.2739 16.5042 93.7033 16.6776 93.0366 16.6776C92.4926 16.6776 92.0046 16.5576 91.5726 16.3176C91.1459 16.0722 90.8126 15.7336 90.5726 15.3016C90.3326 14.8696 90.2126 14.3762 90.2126 13.8216ZM96.3544 15.5416C96.5357 15.3976 96.6184 15.3309 96.6024 15.3416C97.125 14.9096 97.5357 14.5549 97.8344 14.2776C98.1384 14.0002 98.3944 13.7096 98.6024 13.4056C98.8104 13.1016 98.9144 12.8056 98.9144 12.5176C98.9144 12.2989 98.8637 12.1282 98.7624 12.0056C98.661 11.8829 98.509 11.8216 98.3064 11.8216C98.1037 11.8216 97.9437 11.8989 97.8264 12.0536C97.7144 12.2029 97.6584 12.4162 97.6584 12.6936H96.3384C96.349 12.2402 96.445 11.8616 96.6264 11.5576C96.813 11.2536 97.0557 11.0296 97.3544 10.8856C97.6584 10.7416 97.9944 10.6696 98.3624 10.6696C98.997 10.6696 99.4744 10.8322 99.7944 11.1576C100.12 11.4829 100.282 11.9069 100.282 12.4296C100.282 13.0002 100.088 13.5309 99.6984 14.0216C99.309 14.5069 98.813 14.9816 98.2104 15.4456H100.37V16.5576H96.3544V15.5416Z"
      fill="white"
    />
    <rect
      x="79"
      y="107"
      width="32"
      height="24.1828"
      rx="12.0914"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M87.8798 116.475V117.571H86.3918V122.091H85.0238V117.571H83.5358V116.475H87.8798ZM91.4303 122.091L90.2623 119.971H89.9343V122.091H88.5663V116.475H90.8623C91.305 116.475 91.681 116.553 91.9903 116.707C92.305 116.862 92.5396 117.075 92.6943 117.347C92.849 117.614 92.9263 117.913 92.9263 118.243C92.9263 118.617 92.8196 118.95 92.6063 119.243C92.3983 119.537 92.089 119.745 91.6783 119.867L92.9743 122.091H91.4303ZM89.9343 119.003H90.7823C91.033 119.003 91.2196 118.942 91.3423 118.819C91.4703 118.697 91.5343 118.523 91.5343 118.299C91.5343 118.086 91.4703 117.918 91.3423 117.795C91.2196 117.673 91.033 117.611 90.7823 117.611H89.9343V119.003ZM98.6011 116.475L96.6571 120.235V122.091H95.2891V120.235L93.3451 116.475H94.8971L95.9851 118.827L97.0651 116.475H98.6011ZM103.432 118.283C103.432 118.609 103.358 118.907 103.208 119.179C103.059 119.446 102.83 119.662 102.52 119.827C102.211 119.993 101.827 120.075 101.368 120.075H100.52V122.091H99.1523V116.475H101.368C101.816 116.475 102.195 116.553 102.504 116.707C102.814 116.862 103.046 117.075 103.2 117.347C103.355 117.619 103.432 117.931 103.432 118.283ZM101.264 118.987C101.526 118.987 101.72 118.926 101.848 118.803C101.976 118.681 102.04 118.507 102.04 118.283C102.04 118.059 101.976 117.886 101.848 117.763C101.72 117.641 101.526 117.579 101.264 117.579H100.52V118.987H101.264ZM103.864 117.523V116.251H106.08V122.091H104.656V117.523H103.864Z"
      fill="white"
    />
    <rect
      x="186"
      y="68"
      width="45"
      height="17.8743"
      rx="8.93713"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M192.966 79.9931C192.555 79.9931 192.187 79.9265 191.862 79.7931C191.536 79.6598 191.275 79.4625 191.078 79.2011C190.886 78.9398 190.784 78.6251 190.774 78.2571H192.23C192.251 78.4651 192.323 78.6251 192.446 78.7371C192.568 78.8438 192.728 78.8971 192.926 78.8971C193.128 78.8971 193.288 78.8518 193.406 78.7611C193.523 78.6651 193.582 78.5345 193.582 78.3691C193.582 78.2305 193.534 78.1158 193.438 78.0251C193.347 77.9345 193.232 77.8598 193.094 77.8011C192.96 77.7425 192.768 77.6758 192.518 77.6011C192.155 77.4891 191.859 77.3771 191.63 77.2651C191.4 77.1531 191.203 76.9878 191.038 76.7691C190.872 76.5505 190.79 76.2651 190.79 75.9131C190.79 75.3905 190.979 74.9825 191.358 74.6891C191.736 74.3905 192.23 74.2411 192.838 74.2411C193.456 74.2411 193.955 74.3905 194.334 74.6891C194.712 74.9825 194.915 75.3931 194.942 75.9211H193.462C193.451 75.7398 193.384 75.5985 193.262 75.4971C193.139 75.3905 192.982 75.3371 192.789 75.3371C192.624 75.3371 192.491 75.3825 192.39 75.4731C192.288 75.5585 192.238 75.6838 192.238 75.8491C192.238 76.0305 192.323 76.1718 192.493 76.2731C192.664 76.3745 192.931 76.4838 193.294 76.6011C193.656 76.7238 193.95 76.8411 194.174 76.9531C194.403 77.0651 194.6 77.2278 194.766 77.4411C194.931 77.6545 195.014 77.9291 195.014 78.2651C195.014 78.5851 194.931 78.8758 194.766 79.1371C194.606 79.3985 194.371 79.6065 194.062 79.7611C193.752 79.9158 193.387 79.9931 192.966 79.9931ZM197.223 78.8811H199.015V79.9371H195.855V74.3211H197.223V78.8811ZM199.436 77.1211C199.436 76.5665 199.556 76.0731 199.796 75.6411C200.036 75.2038 200.369 74.8651 200.796 74.6251C201.228 74.3798 201.716 74.2571 202.26 74.2571C202.927 74.2571 203.497 74.4331 203.972 74.7851C204.447 75.1371 204.764 75.6171 204.924 76.2251H203.42C203.308 75.9905 203.148 75.8118 202.94 75.6891C202.737 75.5665 202.505 75.5051 202.244 75.5051C201.823 75.5051 201.481 75.6518 201.22 75.9451C200.959 76.2385 200.828 76.6305 200.828 77.1211C200.828 77.6118 200.959 78.0038 201.22 78.2971C201.481 78.5905 201.823 78.7371 202.244 78.7371C202.505 78.7371 202.737 78.6758 202.94 78.5531C203.148 78.4305 203.308 78.2518 203.42 78.0171H204.924C204.764 78.6251 204.447 79.1051 203.972 79.4571C203.497 79.8038 202.927 79.9771 202.26 79.9771C201.716 79.9771 201.228 79.8571 200.796 79.6171C200.369 79.3718 200.036 79.0331 199.796 78.6011C199.556 78.1691 199.436 77.6758 199.436 77.1211ZM205.578 78.8411C205.759 78.6971 205.842 78.6305 205.826 78.6411C206.348 78.2091 206.759 77.8545 207.058 77.5771C207.362 77.2998 207.618 77.0091 207.826 76.7051C208.034 76.4011 208.138 76.1051 208.138 75.8171C208.138 75.5985 208.087 75.4278 207.986 75.3051C207.884 75.1825 207.732 75.1211 207.53 75.1211C207.327 75.1211 207.167 75.1985 207.05 75.3531C206.938 75.5025 206.882 75.7158 206.882 75.9931H205.562C205.572 75.5398 205.668 75.1611 205.85 74.8571C206.036 74.5531 206.279 74.3291 206.578 74.1851C206.882 74.0411 207.218 73.9691 207.586 73.9691C208.22 73.9691 208.698 74.1318 209.018 74.4571C209.343 74.7825 209.506 75.2065 209.506 75.7291C209.506 76.2998 209.311 76.8305 208.922 77.3211C208.532 77.8065 208.036 78.2811 207.434 78.7451H209.594V79.8571H205.578V78.8411ZM210.228 78.8971V77.7931L212.756 74.1771H214.284V77.7131H214.94V78.8971H214.284V79.9371H212.916V78.8971H210.228ZM213.012 75.6811L211.668 77.7131H213.012V75.6811ZM219.242 78.9451H217.146L216.81 79.9371H215.378L217.41 74.3211H218.994L221.026 79.9371H219.578L219.242 78.9451ZM218.89 77.8891L218.194 75.8331L217.506 77.8891H218.89ZM221.54 78.8971V77.7931L224.068 74.1771H225.596V77.7131H226.252V78.8971H225.596V79.9371H224.228V78.8971H221.54ZM224.324 75.6811L222.98 77.7131H224.324V75.6811Z"
      fill="white"
    />
    <rect
      x="115.849"
      y="68.8375"
      width="24"
      height="18.9257"
      rx="9.46285"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M124.729 75.6844V76.7804H123.241V81.3004H121.873V76.7804H120.385V75.6844H124.729ZM130.232 75.6844L128.288 79.4444V81.3004H126.92V79.4444L124.976 75.6844H126.528L127.616 78.0364L128.696 75.6844H130.232ZM133.647 81.3004L132.479 79.1804H132.151V81.3004H130.783V75.6844H133.079C133.522 75.6844 133.898 75.7617 134.207 75.9164C134.522 76.071 134.756 76.2844 134.911 76.5564C135.066 76.823 135.143 77.1217 135.143 77.4524C135.143 77.8257 135.036 78.159 134.823 78.4524C134.615 78.7457 134.306 78.9537 133.895 79.0764L135.191 81.3004H133.647ZM132.151 78.2124H132.999C133.25 78.2124 133.436 78.151 133.559 78.0284C133.687 77.9057 133.751 77.7324 133.751 77.5084C133.751 77.295 133.687 77.127 133.559 77.0044C133.436 76.8817 133.25 76.8204 132.999 76.8204H132.151V78.2124Z"
      fill="white"
    />
    <rect
      x="148.152"
      y="50.9633"
      width="47"
      height="17.8743"
      rx="8.93713"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M154.172 61.8444H155.964V62.9004H152.804V57.2844H154.172V61.8444ZM157.985 57.2844V62.9004H156.617V57.2844H157.985ZM164 62.9004H162.632L160.344 59.4364V62.9004H158.976V57.2844H160.344L162.632 60.7644V57.2844H164V62.9004ZM164.76 60.0844C164.76 59.5297 164.88 59.0364 165.12 58.6044C165.36 58.1671 165.693 57.8284 166.12 57.5884C166.552 57.3431 167.04 57.2204 167.584 57.2204C168.25 57.2204 168.821 57.3964 169.296 57.7484C169.77 58.1004 170.088 58.5804 170.248 59.1884H168.744C168.632 58.9537 168.472 58.7751 168.264 58.6524C168.061 58.5297 167.829 58.4684 167.568 58.4684C167.146 58.4684 166.805 58.6151 166.544 58.9084C166.282 59.2017 166.152 59.5937 166.152 60.0844C166.152 60.5751 166.282 60.9671 166.544 61.2604C166.805 61.5537 167.146 61.7004 167.568 61.7004C167.829 61.7004 168.061 61.6391 168.264 61.5164C168.472 61.3937 168.632 61.2151 168.744 60.9804H170.248C170.088 61.5884 169.77 62.0684 169.296 62.4204C168.821 62.7671 168.25 62.9404 167.584 62.9404C167.04 62.9404 166.552 62.8204 166.12 62.5804C165.693 62.3351 165.36 61.9964 165.12 61.5644C164.88 61.1324 164.76 60.6391 164.76 60.0844ZM170.949 59.9004C170.949 58.9831 171.125 58.2604 171.477 57.7324C171.835 57.2044 172.408 56.9404 173.197 56.9404C173.987 56.9404 174.557 57.2044 174.909 57.7324C175.267 58.2604 175.445 58.9831 175.445 59.9004C175.445 60.8284 175.267 61.5564 174.909 62.0844C174.557 62.6124 173.987 62.8764 173.197 62.8764C172.408 62.8764 171.835 62.6124 171.477 62.0844C171.125 61.5564 170.949 60.8284 170.949 59.9004ZM174.101 59.9004C174.101 59.3617 174.043 58.9484 173.925 58.6604C173.808 58.3671 173.565 58.2204 173.197 58.2204C172.829 58.2204 172.587 58.3671 172.469 58.6604C172.352 58.9484 172.293 59.3617 172.293 59.9004C172.293 60.2631 172.315 60.5644 172.357 60.8044C172.4 61.0391 172.485 61.2311 172.613 61.3804C172.747 61.5244 172.941 61.5964 173.197 61.5964C173.453 61.5964 173.645 61.5244 173.773 61.3804C173.907 61.2311 173.995 61.0391 174.037 60.8044C174.08 60.5644 174.101 60.2631 174.101 59.9004ZM176.12 61.8044C176.302 61.6604 176.384 61.5937 176.368 61.6044C176.891 61.1724 177.302 60.8177 177.6 60.5404C177.904 60.2631 178.16 59.9724 178.368 59.6684C178.576 59.3644 178.68 59.0684 178.68 58.7804C178.68 58.5617 178.63 58.3911 178.528 58.2684C178.427 58.1457 178.275 58.0844 178.072 58.0844C177.87 58.0844 177.71 58.1617 177.592 58.3164C177.48 58.4657 177.424 58.6791 177.424 58.9564H176.104C176.115 58.5031 176.211 58.1244 176.392 57.8204C176.579 57.5164 176.822 57.2924 177.12 57.1484C177.424 57.0044 177.76 56.9324 178.128 56.9324C178.763 56.9324 179.24 57.0951 179.56 57.4204C179.886 57.7457 180.048 58.1697 180.048 58.6924C180.048 59.2631 179.854 59.7937 179.464 60.2844C179.075 60.7697 178.579 61.2444 177.976 61.7084H180.136V62.8204H176.12V61.8044ZM180.771 61.8604V60.7564L183.299 57.1404H184.827V60.6764H185.483V61.8604H184.827V62.9004H183.459V61.8604H180.771ZM183.555 58.6444L182.211 60.6764H183.555V58.6444ZM190.265 58.2524H187.769V59.3564C187.875 59.2391 188.025 59.1431 188.217 59.0684C188.409 58.9937 188.617 58.9564 188.841 58.9564C189.241 58.9564 189.571 59.0471 189.833 59.2284C190.099 59.4097 190.294 59.6444 190.417 59.9324C190.539 60.2204 190.601 60.5324 190.601 60.8684C190.601 61.4924 190.425 61.9884 190.073 62.3564C189.721 62.7191 189.225 62.9004 188.585 62.9004C188.158 62.9004 187.787 62.8284 187.473 62.6844C187.158 62.5351 186.915 62.3297 186.745 62.0684C186.574 61.8071 186.481 61.5057 186.465 61.1644H187.801C187.833 61.3297 187.91 61.4684 188.033 61.5804C188.155 61.6871 188.323 61.7404 188.537 61.7404C188.787 61.7404 188.974 61.6604 189.097 61.5004C189.219 61.3404 189.281 61.1271 189.281 60.8604C189.281 60.5991 189.217 60.3991 189.089 60.2604C188.961 60.1217 188.774 60.0524 188.529 60.0524C188.347 60.0524 188.198 60.0977 188.081 60.1884C187.963 60.2737 187.886 60.3884 187.849 60.5324H186.529V57.0524H190.265V58.2524Z"
      fill="white"
    />
    <g clipPath="url(#clip8_1168_39633)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M246.929 5.75189C251.348 5.75189 254.929 9.33361 254.929 13.7519L254.929 25.7519C254.929 30.1702 251.348 33.7519 246.929 33.7519C242.511 33.7519 238.929 30.1702 238.929 25.7519L238.929 13.7519C238.929 9.33361 242.511 5.75189 246.929 5.75189ZM246.929 33.7519C251.348 33.7519 254.929 37.3336 254.929 41.7519L254.929 66.5519V72.9519L254.929 144.552C254.929 148.97 251.348 152.552 246.929 152.552C242.511 152.552 238.929 148.97 238.929 144.552L238.929 72.9519V66.5519L238.929 41.7519C238.929 37.3336 242.511 33.7519 246.929 33.7519Z"
        fill="#F7FAFC"
      />
      <rect
        x="238.929"
        y="14.9519"
        width="15.9997"
        height="1.2"
        fill="#E2E8F0"
      />
      <rect
        x="238.929"
        y="16.5519"
        width="15.9997"
        height="1.2"
        fill="#E2E8F0"
      />
      <path
        d="M238.929 46.1519H254.929V50.9519H238.929V46.1519Z"
        fill="#E2E8F0"
      />
      <path
        d="M238.929 57.3519H254.929V65.3519H238.929V57.3519Z"
        fill="#E2E8F0"
      />
      <path
        d="M238.929 70.9519H254.929V79.7519H238.929V70.9519Z"
        fill="#E2E8F0"
      />
      <path
        d="M238.929 82.5519H254.929V91.3519H238.929V82.5519Z"
        fill="#E2E8F0"
      />
      <rect
        x="238.929"
        y="102.552"
        width="15.9997"
        height="4.8"
        fill="#E2E8F0"
      />
      <rect x="238.929" y="112.952" width="16" height="6" fill="#E2E8F0" />
      <rect x="238.929" y="124.552" width="16" height="12.4" fill="#E2E8F0" />
      <rect x="238.929" y="143.352" width="16" height="3.2" fill="#E2E8F0" />
      <mask
        id="mask11_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="238"
        y="5"
        width="17"
        height="10"
      >
        <rect
          x="238.929"
          y="5.75189"
          width="15.9997"
          height="9.2"
          rx="4.6"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask11_1168_39633)">
        <rect
          width="18.2409"
          height="18.3499"
          transform="translate(233.905 11.2206) rotate(-42.4793)"
          fill="#E2E8F0"
        />
        <line
          x1="248.279"
          y1="22.9397"
          x2="235.887"
          y2="9.40625"
          stroke="#CBD5E0"
        />
        <line
          x1="250.029"
          y1="21.3368"
          x2="237.637"
          y2="7.80334"
          stroke="#CBD5E0"
        />
        <line
          x1="251.78"
          y1="19.734"
          x2="239.388"
          y2="6.2005"
          stroke="#CBD5E0"
        />
        <line
          x1="253.53"
          y1="18.1311"
          x2="241.138"
          y2="4.59765"
          stroke="#CBD5E0"
        />
        <line
          x1="255.281"
          y1="16.5282"
          x2="242.889"
          y2="2.99475"
          stroke="#CBD5E0"
        />
        <line
          x1="257.031"
          y1="14.9254"
          x2="244.639"
          y2="1.3919"
          stroke="#CBD5E0"
        />
      </g>
      <mask
        id="mask12_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="238"
        y="17"
        width="17"
        height="13"
      >
        <rect
          x="238.929"
          y="17.7519"
          width="15.9997"
          height="12"
          rx="6"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask12_1168_39633)">
        <rect
          width="20.9559"
          height="21.5678"
          transform="matrix(0.641967 -0.766732 0.574567 0.818458 233.905 24.8851)"
          fill="#E2E8F0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 248.488 39.9206)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 250.302 37.7538)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 252.117 35.587)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 253.931 33.4202)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 255.745 31.2535)"
          stroke="#CBD5E0"
        />
        <line
          y1="-0.5"
          x2="21.5678"
          y2="-0.5"
          transform="matrix(-0.574567 -0.818458 0.641967 -0.766732 257.559 29.0867)"
          stroke="#CBD5E0"
        />
      </g>
      <mask
        id="mask13_1168_39633"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="238"
        y="26"
        width="17"
        height="11"
      >
        <path
          d="M254.929 26.9519C254.929 28.7559 253.586 28.2174 251.529 29.1826V33.2545C253.586 34.2197 254.929 34.7479 254.929 36.5519L238.929 36.5519C238.929 34.7478 240.273 34.2196 242.329 33.2545V29.1826C240.273 28.2175 238.929 28.756 238.929 26.9519H254.929Z"
          fill="#E2E8F0"
        />
      </mask>
      <g mask="url(#mask13_1168_39633)">
        <path
          d="M238.929 26.9519H254.929V36.0186H238.929V26.9519Z"
          fill="#EDF2F7"
        />
      </g>
    </g>
    <path
      d="M241.095 163.7V161.792H244.419V170.552H242.283V163.7H241.095ZM251.991 163.58H248.247V165.236C248.407 165.06 248.631 164.916 248.919 164.804C249.207 164.692 249.519 164.636 249.855 164.636C250.455 164.636 250.951 164.772 251.343 165.044C251.743 165.316 252.035 165.668 252.219 166.1C252.403 166.532 252.495 167 252.495 167.504C252.495 168.44 252.231 169.184 251.703 169.736C251.175 170.28 250.431 170.552 249.471 170.552C248.831 170.552 248.275 170.444 247.803 170.228C247.331 170.004 246.967 169.696 246.711 169.304C246.455 168.912 246.315 168.46 246.291 167.948H248.295C248.343 168.196 248.459 168.404 248.643 168.572C248.827 168.732 249.079 168.812 249.399 168.812C249.775 168.812 250.055 168.692 250.239 168.452C250.423 168.212 250.515 167.892 250.515 167.492C250.515 167.1 250.419 166.8 250.227 166.592C250.035 166.384 249.755 166.28 249.387 166.28C249.115 166.28 248.891 166.348 248.715 166.484C248.539 166.612 248.423 166.784 248.367 167H246.387V161.78H251.991V163.58Z"
      fill="#4A5568"
    />
    <rect
      x="219.102"
      y="18.369"
      width="31"
      height="17.8743"
      rx="8.93713"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M226.328 30.3622C225.8 30.3622 225.315 30.2395 224.872 29.9942C224.435 29.7488 224.085 29.4075 223.824 28.9702C223.568 28.5275 223.44 28.0315 223.44 27.4822C223.44 26.9328 223.568 26.4395 223.824 26.0022C224.085 25.5648 224.435 25.2235 224.872 24.9782C225.315 24.7328 225.8 24.6102 226.328 24.6102C226.856 24.6102 227.339 24.7328 227.776 24.9782C228.219 25.2235 228.565 25.5648 228.816 26.0022C229.072 26.4395 229.2 26.9328 229.2 27.4822C229.2 28.0315 229.072 28.5275 228.816 28.9702C228.56 29.4075 228.213 29.7488 227.776 29.9942C227.339 30.2395 226.856 30.3622 226.328 30.3622ZM226.328 29.1142C226.776 29.1142 227.133 28.9648 227.4 28.6662C227.672 28.3675 227.808 27.9728 227.808 27.4822C227.808 26.9862 227.672 26.5915 227.4 26.2982C227.133 25.9995 226.776 25.8502 226.328 25.8502C225.875 25.8502 225.512 25.9968 225.24 26.2902C224.973 26.5835 224.84 26.9808 224.84 27.4822C224.84 27.9782 224.973 28.3755 225.24 28.6742C225.512 28.9675 225.875 29.1142 226.328 29.1142ZM229.729 27.4902C229.729 26.9355 229.849 26.4422 230.089 26.0102C230.329 25.5728 230.662 25.2342 231.089 24.9942C231.521 24.7488 232.009 24.6262 232.553 24.6262C233.22 24.6262 233.79 24.8022 234.265 25.1542C234.74 25.5062 235.057 25.9862 235.217 26.5942H233.713C233.601 26.3595 233.441 26.1808 233.233 26.0582C233.03 25.9355 232.798 25.8742 232.537 25.8742C232.116 25.8742 231.774 26.0208 231.513 26.3142C231.252 26.6075 231.121 26.9995 231.121 27.4902C231.121 27.9808 231.252 28.3728 231.513 28.6662C231.774 28.9595 232.116 29.1062 232.537 29.1062C232.798 29.1062 233.03 29.0448 233.233 28.9222C233.441 28.7995 233.601 28.6208 233.713 28.3862H235.217C235.057 28.9942 234.74 29.4742 234.265 29.8262C233.79 30.1728 233.22 30.3462 232.553 30.3462C232.009 30.3462 231.521 30.2262 231.089 29.9862C230.662 29.7408 230.329 29.4022 230.089 28.9702C229.849 28.5382 229.729 28.0448 229.729 27.4902ZM239.551 29.3142H237.455L237.119 30.3062H235.687L237.719 24.6902H239.303L241.335 30.3062H239.887L239.551 29.3142ZM239.199 28.2582L238.503 26.2022L237.815 28.2582H239.199ZM241.769 29.2102C241.95 29.0662 242.033 28.9995 242.017 29.0102C242.54 28.5782 242.95 28.2235 243.249 27.9462C243.553 27.6688 243.809 27.3782 244.017 27.0742C244.225 26.7702 244.329 26.4742 244.329 26.1862C244.329 25.9675 244.278 25.7968 244.177 25.6742C244.076 25.5515 243.924 25.4902 243.721 25.4902C243.518 25.4902 243.358 25.5675 243.241 25.7222C243.129 25.8715 243.073 26.0848 243.073 26.3622H241.753C241.764 25.9088 241.86 25.5302 242.041 25.2262C242.228 24.9222 242.47 24.6982 242.769 24.5542C243.073 24.4102 243.409 24.3382 243.777 24.3382C244.412 24.3382 244.889 24.5008 245.209 24.8262C245.534 25.1515 245.697 25.5755 245.697 26.0982C245.697 26.6688 245.502 27.1995 245.113 27.6902C244.724 28.1755 244.228 28.6502 243.625 29.1142H245.785V30.2262H241.769V29.2102Z"
      fill="white"
    />
    <rect
      x="244"
      y="32"
      width="35"
      height="17.8743"
      rx="8.93713"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M253.829 38.3211V43.9371H252.461V41.6251H250.333V43.9371H248.965V38.3211H250.333V40.5211H252.461V38.3211H253.829ZM256.184 39.4171V40.5531H258.016V41.6091H256.184V42.8411H258.256V43.9371H254.816V38.3211H258.256V39.4171H256.184ZM262.008 43.9371L260.84 41.8171H260.512V43.9371H259.144V38.3211H261.44C261.883 38.3211 262.259 38.3985 262.568 38.5531C262.883 38.7078 263.118 38.9211 263.272 39.1931C263.427 39.4598 263.504 39.7585 263.504 40.0891C263.504 40.4625 263.398 40.7958 263.184 41.0891C262.976 41.3825 262.667 41.5905 262.256 41.7131L263.552 43.9371H262.008ZM260.512 40.8491H261.36C261.611 40.8491 261.798 40.7878 261.92 40.6651C262.048 40.5425 262.112 40.3691 262.112 40.1451C262.112 39.9318 262.048 39.7638 261.92 39.6411C261.798 39.5185 261.611 39.4571 261.36 39.4571H260.512V40.8491ZM264.131 41.1211C264.131 40.5665 264.251 40.0731 264.491 39.6411C264.731 39.2038 265.065 38.8651 265.491 38.6251C265.923 38.3798 266.411 38.2571 266.955 38.2571C267.622 38.2571 268.193 38.4331 268.667 38.7851C269.142 39.1371 269.459 39.6171 269.619 40.2251H268.115C268.003 39.9905 267.843 39.8118 267.635 39.6891C267.433 39.5665 267.201 39.5051 266.939 39.5051C266.518 39.5051 266.177 39.6518 265.915 39.9451C265.654 40.2385 265.523 40.6305 265.523 41.1211C265.523 41.6118 265.654 42.0038 265.915 42.2971C266.177 42.5905 266.518 42.7371 266.939 42.7371C267.201 42.7371 267.433 42.6758 267.635 42.5531C267.843 42.4305 268.003 42.2518 268.115 42.0171H269.619C269.459 42.6251 269.142 43.1051 268.667 43.4571C268.193 43.8038 267.622 43.9771 266.955 43.9771C266.411 43.9771 265.923 43.8571 265.491 43.6171C265.065 43.3718 264.731 43.0331 264.491 42.6011C264.251 42.1691 264.131 41.6758 264.131 41.1211ZM270.273 42.8411C270.454 42.6971 270.537 42.6305 270.521 42.6411C271.044 42.2091 271.454 41.8545 271.753 41.5771C272.057 41.2998 272.313 41.0091 272.521 40.7051C272.729 40.4011 272.833 40.1051 272.833 39.8171C272.833 39.5985 272.782 39.4278 272.681 39.3051C272.58 39.1825 272.428 39.1211 272.225 39.1211C272.022 39.1211 271.862 39.1985 271.745 39.3531C271.633 39.5025 271.577 39.7158 271.577 39.9931H270.257C270.268 39.5398 270.364 39.1611 270.545 38.8571C270.732 38.5531 270.974 38.3291 271.273 38.1851C271.577 38.0411 271.913 37.9691 272.281 37.9691C272.916 37.9691 273.393 38.1318 273.713 38.4571C274.038 38.7825 274.201 39.2065 274.201 39.7291C274.201 40.2998 274.006 40.8305 273.617 41.3211C273.228 41.8065 272.732 42.2811 272.129 42.7451H274.289V43.8571H270.273V42.8411Z"
      fill="white"
    />
    <rect
      x="259.732"
      y="52.0147"
      width="30"
      height="17.8743"
      rx="8.93713"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M270.756 58.3358V63.9518H269.388V60.5838L268.132 63.9518H267.028L265.764 60.5758V63.9518H264.396V58.3358H266.012L267.588 62.2238L269.148 58.3358H270.756ZM271.508 61.1358C271.508 60.5812 271.628 60.0878 271.868 59.6558C272.108 59.2185 272.441 58.8798 272.868 58.6398C273.3 58.3945 273.788 58.2718 274.332 58.2718C274.998 58.2718 275.569 58.4478 276.044 58.7998C276.518 59.1518 276.836 59.6318 276.996 60.2398H275.492C275.38 60.0052 275.22 59.8265 275.012 59.7038C274.809 59.5812 274.577 59.5198 274.316 59.5198C273.894 59.5198 273.553 59.6665 273.292 59.9598C273.03 60.2532 272.9 60.6452 272.9 61.1358C272.9 61.6265 273.03 62.0185 273.292 62.3118C273.553 62.6052 273.894 62.7518 274.316 62.7518C274.577 62.7518 274.809 62.6905 275.012 62.5678C275.22 62.4452 275.38 62.2665 275.492 62.0318H276.996C276.836 62.6398 276.518 63.1198 276.044 63.4718C275.569 63.8185 274.998 63.9918 274.332 63.9918C273.788 63.9918 273.3 63.8718 272.868 63.6318C272.441 63.3865 272.108 63.0478 271.868 62.6158C271.628 62.1838 271.508 61.6905 271.508 61.1358ZM277.554 59.3838V58.1118H279.77V63.9518H278.346V59.3838H277.554ZM283.705 63.9518L282.537 61.8318H282.209V63.9518H280.841V58.3358H283.137C283.58 58.3358 283.956 58.4132 284.265 58.5678C284.58 58.7225 284.815 58.9358 284.969 59.2078C285.124 59.4745 285.201 59.7732 285.201 60.1038C285.201 60.4772 285.095 60.8105 284.881 61.1038C284.673 61.3972 284.364 61.6052 283.953 61.7278L285.249 63.9518H283.705ZM282.209 60.8638H283.057C283.308 60.8638 283.495 60.8025 283.617 60.6798C283.745 60.5572 283.809 60.3838 283.809 60.1598C283.809 59.9465 283.745 59.7785 283.617 59.6558C283.495 59.5332 283.308 59.4718 283.057 59.4718H282.209V60.8638Z"
      fill="white"
    />
    <rect
      x="297.453"
      y="26.7805"
      width="28"
      height="17.8743"
      rx="8.93713"
      fill="#008777"
      fillOpacity="0.8"
    />
    <path
      d="M306.686 34.9096C306.686 35.2349 306.611 35.5336 306.462 35.8056C306.312 36.0723 306.083 36.2883 305.774 36.4536C305.464 36.6189 305.08 36.7016 304.622 36.7016H303.774V38.7176H302.406V33.1016H304.622C305.07 33.1016 305.448 33.1789 305.758 33.3336C306.067 33.4883 306.299 33.7016 306.454 33.9736C306.608 34.2456 306.686 34.5576 306.686 34.9096ZM304.518 35.6136C304.779 35.6136 304.974 35.5523 305.102 35.4296C305.23 35.3069 305.294 35.1336 305.294 34.9096C305.294 34.6856 305.23 34.5123 305.102 34.3896C304.974 34.2669 304.779 34.2056 304.518 34.2056H303.774V35.6136H304.518ZM308.766 33.1016V38.7176H307.398V33.1016H308.766ZM313.485 34.8776C313.384 34.6909 313.237 34.5496 313.045 34.4536C312.859 34.3523 312.637 34.3016 312.381 34.3016C311.939 34.3016 311.584 34.4483 311.317 34.7416C311.051 35.0296 310.917 35.4163 310.917 35.9016C310.917 36.4189 311.056 36.8243 311.333 37.1176C311.616 37.4056 312.003 37.5496 312.493 37.5496C312.829 37.5496 313.112 37.4643 313.341 37.2936C313.576 37.1229 313.747 36.8776 313.853 36.5576H312.117V35.5496H315.093V36.8216C314.992 37.1629 314.819 37.4803 314.573 37.7736C314.333 38.0669 314.027 38.3043 313.653 38.4856C313.28 38.6669 312.859 38.7576 312.389 38.7576C311.835 38.7576 311.339 38.6376 310.901 38.3976C310.469 38.1523 310.131 37.8136 309.885 37.3816C309.645 36.9496 309.525 36.4563 309.525 35.9016C309.525 35.3469 309.645 34.8536 309.885 34.4216C310.131 33.9843 310.469 33.6456 310.901 33.4056C311.333 33.1603 311.827 33.0376 312.381 33.0376C313.053 33.0376 313.619 33.2003 314.077 33.5256C314.541 33.8509 314.848 34.3016 314.997 34.8776H313.485ZM317.195 33.1016V36.4616C317.195 36.7976 317.278 37.0563 317.443 37.2376C317.608 37.4189 317.851 37.5096 318.171 37.5096C318.491 37.5096 318.736 37.4189 318.907 37.2376C319.078 37.0563 319.163 36.7976 319.163 36.4616V33.1016H320.531V36.4536C320.531 36.9549 320.424 37.3789 320.211 37.7256C319.998 38.0723 319.71 38.3336 319.347 38.5096C318.99 38.6856 318.59 38.7736 318.147 38.7736C317.704 38.7736 317.307 38.6883 316.955 38.5176C316.608 38.3416 316.334 38.0803 316.131 37.7336C315.928 37.3816 315.827 36.9549 315.827 36.4536V33.1016H317.195Z"
      fill="white"
    />
    <defs>
      <clipPath id="clip0_1168_39633">
        <rect
          width="15.9999"
          height="272"
          fill="white"
          transform="translate(24.9004 5.76862)"
        />
      </clipPath>
      <clipPath id="clip1_1168_39633">
        <rect
          width="15.9999"
          height="260"
          fill="white"
          transform="translate(60.5718 5.76862)"
        />
      </clipPath>
      <clipPath id="clip2_1168_39633">
        <rect
          width="15.9999"
          height="250.8"
          fill="white"
          transform="translate(96.2432 5.76862)"
        />
      </clipPath>
      <clipPath id="clip3_1168_39633">
        <rect
          width="15.9999"
          height="196.4"
          fill="white"
          transform="translate(131.914 5.76862)"
        />
      </clipPath>
      <clipPath id="clip4_1168_39633">
        <rect
          width="15.9999"
          height="169.6"
          fill="white"
          transform="translate(167.586 5.75189)"
        />
      </clipPath>
      <clipPath id="clip5_1168_39633">
        <rect
          width="15.9999"
          height="152"
          fill="white"
          transform="translate(203.258 5.75189)"
        />
      </clipPath>
      <clipPath id="clip6_1168_39633">
        <rect
          width="15.9999"
          height="96"
          fill="white"
          transform="translate(310.272 5.75189)"
        />
      </clipPath>
      <clipPath id="clip7_1168_39633">
        <rect
          width="15.9999"
          height="125.6"
          fill="white"
          transform="translate(274.601 5.75189)"
        />
      </clipPath>
      <clipPath id="clip8_1168_39633">
        <rect
          width="15.9999"
          height="146.8"
          fill="white"
          transform="translate(238.929 5.75189)"
        />
      </clipPath>
    </defs>
  </svg>
);
